<script>
import formatPrice from '@utils/format-price'
import formatCurrency from '@utils/format-currency'
import formatOrderPrepaid from '@utils/format-order-prepaid'
import { prepaidFormatExpiredDate, prepaidFormatUsedTimes, prepaidIsExpired, prepaidUsedStepList } from '@utils/ipetbooking-prepaid'
import { orderIsCanPay, orderIsOffline } from '@utils/ipetbooking-order'
import formatDate from '@utils/format-date'
import { conditionList } from '@utils/is-condition'
import { authComputed, merchantComputed } from '@store/helpers'

export default {
  components: {
    ReservationSectionTitlePrepaid: () => import('@components/Reservation/ReservationSectionTitlePrepaid'),
    ListPrepaidOrderApplicable: () => import('@components/List/ListPrepaidOrderApplicable.Jtails'),
    ListHistoryJtails: () => import('@components/List/ListHistory.Jtails'),
  },
  props: {
    value: {
      type: Number,
      default: -1,
    },
    orderList: {
      type: Array,
      default: () => [],
    },
    orderPagination: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: 'reservation',
      validator(value) {
        return ['reservation', 'prepaid-reservation', 'order'].includes(value)
      },
    },
    loadingText: {
      type: String,
      default: '',
    },
    tempSubmitData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    serviceType: {
      type: String,
      default: 'cosmetic',
      validator(value) {
        return ['cosmetic', 'daycare'].includes(value)
      },
    },
  },
  data() {
    return {
      filter: {
        storeAlias: this.$route.query.filterStoreAlias || '',
      },
    }
  },
  computed: {
    ...authComputed,
    ...merchantComputed,
    dataValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    buttonText() {
      const buttonTextMap = {
        order: '查看',
        'prepaid-reservation': '選擇',
        reservation: '選擇',
      }
      return buttonTextMap[this.type] || ''
    },
    formatOrderList() {
      return this.orderList.map((item) => {
        return {
          storeList: item.prepaid.stores,
          head: [
            {
              title: '',
              titleClass: '',
              text: item.prepaid.title,
              textClass: '',
              class: '',
            },
            {
              title: '使用期限',
              titleClass: '',
              text: prepaidFormatExpiredDate(item),
              textClass: '',
              class: '',
            },
            {
              title: '剩餘抵用次數',
              titleClass: '',
              text: this.formatUsedTimesText(item),
              textClass: '',
              class: '',
            },
          ],
          body: [
            {
              title: '訂單狀態',
              titleClass: '',
              text: formatOrderPrepaid(item.status).title,
              textClass: `text-${formatOrderPrepaid(item.status).color}`,
              class: '',
            },
            {
              title: '總計',
              titleClass: '',
              text: `NT$ ${formatCurrency(item.total)}`,
              textClass: '',
              class: '',
            },
            {
              title: '訂單成立日期',
              titleClass: '',
              text: formatDate(item.createdDate, 'yyyy/MM/dd'),
              textClass: '',
              class: '',
            },
          ],
          foot: conditionList([
            {
              type: 'button',
              text: '預約',
              class: 'flex-grow-1',
              buttonClass: this.$globalIsDingBeauty ? 'isStyleSecondary isOutline3 isSmall isFull ' : 'isStylePrimary isOutline3 isSmall isFull isRadius',
              onClick: () => {
                this.goToMemberPrepaidItemApplicable(item)
              },
              condition: () => {
                return this.isSiteEnabled
              },
            },
            {
              type: 'dropdown',
              text: '更多',
              class: 'flex-grow-1',
              buttonClass: this.$globalIsDingBeauty ? 'isStyleSecondary isOutline3 isSmall isFull ' : 'isStylePrimary isOutline3 isSmall isFull isRadius',
              dropdown: this.orderDropdownList(item),
            },
          ]),
        }
      })
    },
  },
  methods: {
    formatPrice,
    formatCurrency,
    formatOrderPrepaid,
    prepaidFormatExpiredDate,
    prepaidIsExpired,
    goToMemberPrepaidItemApplicable(order) {
      this.$router.push({
        name: 'member-prepaid-item',
        params: {
          prepaidOrderId: order.id,
        },
        query: {
          activeTab: 'applicable',
        },
      })
    },
    formatUsedTimesText(item, isPrimary = true) {
      const { times, used, bonusTimes, bonusUsed } = item
      if (!isPrimary) {
        return bonusTimes - bonusUsed > 0 ? `${prepaidFormatUsedTimes(bonusTimes - bonusUsed)}/${prepaidFormatUsedTimes(bonusTimes)}` : '使用完畢'
      }
      return times - used > 0 ? `${prepaidFormatUsedTimes(times - used)}/${prepaidFormatUsedTimes(times)}` : '使用完畢'
    },
    orderDropdownList(item) {
      return conditionList([
        {
          text: '前往付款',
          class: '',
          onClick: () => {
            this.goToPrepaidUnpaidCheckout(item)
          },
          condition: () => {
            return this.isCanPay(item) && item.status === 2 && orderIsCanPay(item) && (item.paymentMethod === 'Credit' || item.paymentMethod === null)
          },
        },
        {
          text: '查看訂單',
          class: '',
          onClick: () => {
            this.goToMemberPrepaidItem(item)
          },
        },
        {
          text: '再次購買',
          class: '',
          onClick: () => {
            this.onClickRepurchase(item)
          },
          condition: () => {
            return this.currentMerchant.prepaidSetting.isEnabled
          },
        },
        {
          text: '聯繫我們',
          class: '',
          onClick: () => {
            this.openDialogContact(item.prepaid.stores)
          },
        },
      ])
    },
    onClickItem(index, order = {}) {
      switch (this.type) {
        case 'order':
          this.goToMemberPrepaidItem(order)
          break
        case 'reservation':
        case 'prepaid-reservation':
        default:
          this.dataValue = index
          break
      }
    },
    goToMemberPrepaidItem(order) {
      this.$router.push({
        name: 'member-prepaid-item',
        params: {
          prepaidOrderId: order.id,
        },
      })
    },
    openDialogContact(storeList) {
      this.$globalDialog('DialogContact', {
        storeList,
      })
    },
    isCanPay(item) {
      return (
        !this.isOffline({
          order: item,
          ordertype: 'order',
          type: 'prepaid',
          isList: true,
        }) &&
        item.status === 2 &&
        orderIsCanPay(item) &&
        (item.paymentMethod === 'Credit' || item.paymentMethod === null)
      )
    },
    isOffline(item) {
      return orderIsOffline(item)
    },
    stepList(orderItem) {
      return prepaidUsedStepList({
        ...orderItem,
      })
    },
    openDialogReservationJtails(reservationItem) {
      this.$globalDialog('DialogReservation', {
        ...reservationItem,
      })
    },
    openDialogPrepaidJtails(orderItem) {
      this.$globalDialog('DialogPrepaid', {
        ...orderItem.prepaid,
      })
    },
    onClickRepurchase(orderItem) {
      if (orderItem.prepaid.state) {
        if (this.isBlock) {
          this.$globalDialog('DialogBlock', {})
          return
        }
        const loadingMaskCheckOutCart = this.$loading({
          lock: true,
          text: '正在前往結帳',
          spinner: `fal fa-circle-notch fa-spin`,
          background: 'rgba(81, 176, 202, 0.3)',
          customClass: 'isStyleCheckout',
        })

        const prepaidAlias = orderItem.prepaid.alias

        this.tryToStoreCart({ prepaidAlias })
          .then(() => {
            const goToPrepaidCheckout = () => {
              this.$router.push({
                name: 'prepaid-checkout',
                params: {
                  prepaidAlias,
                },
              })
            }

            goToPrepaidCheckout()
          })
          .catch((e) => {
            if (e.status === 'STATUS_CODE_UNDEFINED') {
              this.$globalDialog('DialogBlock', {})
            }
          })
          .finally(() => {
            loadingMaskCheckOutCart.close()
          })
      } else {
        this.openDialogRepurchase(orderItem.prepaid.stores)
      }
    },
    async tryToStoreCart({ prepaidAlias }) {
      await this.$store
        .dispatch('cart/storeCart', {
          prepaidAlias,
        })
        .then(() => {
          return true
        })
    },
    openDialogRepurchase(storeList) {
      this.$globalDialog('DialogRepurchase', {
        storeList,
      })
    },
    goToPrepaidUnpaidCheckout(order) {
      this.$router.push({
        name: 'prepaid-unpaid-checkout',
        params: {
          storeType: order.prepaid.stores[0].storeType,
          prepaidAlias: order.prepaid.alias,
          orderId: order.id,
        },
      })
    },
    useMultiple(times) {
      if (times % 6 === 0) {
        return 6
      }

      if (times % 5 === 0) {
        return 5
      }

      return 4
    },
  },
}
</script>
<!-- section template -->
<template>
  <div :class="[$style.listPrepaidOrderJtails]">
    <ReservationSectionTitlePrepaid v-if="type !== 'order'" class="d-lg-none mb-3" :category="tempSubmitData.category" :size-alias="tempSubmitData.sizeAlias" />
    <BaseOrderListJtails
      v-if="type === 'order'"
      :loading="$isLoading('fetchPrepaidOrderList')"
      :loading-text="`取得${currentMerchant.prepaidSetting.title || $t('site.PREPAID_TITLE')}中...`"
      :order-list="formatOrderList"
      class="d-xl-none"
    />
    <ul :class="[$style.orderList, { 'd-none d-xl-block': type === 'order', [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
      <li v-for="(orderItem, index) in orderList" :key="`orderList-${index}`" class="orderList__item" :class="{ isActive: index === dataValue }" @click="onClickItem(index, orderItem)">
        <div v-if="type === 'order'" class="orderList__header mb-3">
          <div class="orderList__status">
            狀態：
            <span class="fw-medium" :class="`text-${formatOrderPrepaid(orderItem.status).color}`">
              {{ formatOrderPrepaid(orderItem.status).title }}
            </span>
          </div>
          <div class="orderList__link">
            <div :class="$style.buttonList">
              <div v-if="currentMerchant.prepaidSetting.isEnabled" class="buttonList__item">
                <BaseButton class="isStylePrimary isText" @click.stop.prevent="onClickRepurchase(orderItem)">
                  再次購買
                </BaseButton>
              </div>
              <div class="buttonList__item">
                <BaseButton class="isStylePrimary isText" @click.stop.prevent.native="openDialogContact(orderItem.prepaid.stores)">
                  聯繫我們
                </BaseButton>
              </div>
            </div>
          </div>
        </div>
        <div class="orderList__imageBox">
          <div class="orderList__image">
            <div class="orderList__imageInner" :style="{ backgroundImage: `url('${orderItem.prepaid.image || require(`@assets/images/${$globalProjectName}/default/plan-default-Image@2x.png`)}')` }">
            </div>
          </div>
        </div>
        <div class="orderList__infoBox">
          <div class="d-flex align-items-center flex-wrap">
            <BaseStoreTagList :store-list="orderItem.prepaid.stores" />
          </div>
          <div class="orderList__title" :class="{ isButton: type !== 'order' }" @click.stop.prevent="type !== 'order' ? openDialogPrepaidJtails(orderItem) : onClickItem(index, orderItem)">
            {{ orderItem.prepaid.title }}<i v-if="type !== 'order'" class="fal fa-info-circle fs-sm ml-1" style="position: relative;top: -1px;"></i>
          </div>
          <div class="orderList__slogan">
            {{ orderItem.prepaid.slogan }}
          </div>
          <div class="orderList__meta" :class="{ prepaidIsExpired: prepaidIsExpired(orderItem.expiredDate) }">
            <span>使用期限：</span>
            <span>{{ prepaidFormatExpiredDate(orderItem) }}</span>
            <span v-if="prepaidIsExpired(orderItem.expiredDate)">(已過期)</span>
          </div>
          <div class="orderList__times" style="margin-bottom: 4px;">
            <span v-if="orderItem.times - orderItem.used > 0" class="mr-2">購買項目抵用次數</span>
            <span class="text-primary font-number">{{ formatUsedTimesText(orderItem) }}</span>
          </div>
          <br />
          <template v-if="orderItem.bonusTimes">
            <div class="orderList__times">
              <span v-if="orderItem.times - orderItem.used > 0" class="mr-2">贈送項目抵用次數</span>
              <span class="text-primary font-number">{{ formatUsedTimesText(orderItem, false) }}</span>
            </div>
          </template>
        </div>
        <div class="orderList__actionBox">
          <div>
            <template v-if="type === 'order'">
              <div class="orderList__price">
                {{ formatPrice(orderItem.total) }}
              </div>
              <div v-if="orderItem.total < orderItem.basePrice" class="orderList__basePrice text-decoration-line-through"> 原價 NT${{ formatCurrency(orderItem.basePrice) }} </div>
            </template>
          </div>
          <div class="orderList__buttonBox">
            <BaseButton
              v-if="type === 'order' && isCanPay(orderItem)"
              class="isStyleSecondary isSmall mr-2"
              :class="{ isRadius: $globalIsJtails }"
              @click.stop.prevent="goToPrepaidUnpaidCheckout(orderItem)"
            >
              前往付款
            </BaseButton>
            <BaseButton v-if="buttonText" class="isStylePrimary isSmall isCol2" :class="{ isOutline4: index !== dataValue, isFull: $globalWindowWidth <= 575, isRadius: $globalIsJtails }">
              {{ buttonText }}
            </BaseButton>
          </div>
        </div>
        <div v-if="type !== 'order' && index === dataValue" class="orderList__reservationBox">
          <hr />
          <ListHistoryJtails v-model="orderItem.used" type="reservation" :history-list="stepList(orderItem)" />
          <ListPrepaidOrderApplicable :type="type" :order-item="orderItem" :temp-submit-data="tempSubmitData" />
        </div>
      </li>
    </ul>
    <BasePre>{{ orderList }}</BasePre>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.listPrepaidOrderJtails {
  :global {
    .listPrepaidOrderJtails {
      &__pagination {
        margin-top: 3rem;
      }
    }
  }
}

.orderList {
  @include list-unstyled;

  :global {
    .orderList {
      &__item {
        display: flex;
        flex-wrap: wrap;
        padding: 1.5rem 1rem;
        cursor: pointer;
        border: 1px solid #c6c6bb;
        transition: border-color 0.3s;

        &:not(:last-child) {
          margin-bottom: 1.875rem;
        }

        &:hover {
          border-color: $color-primary-dark;
        }

        &.isActive {
          background: rgba($color-primary, 0.05);
          border-color: $color-primary-dark;
        }
      }

      &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
      }

      &__link {
        display: flex;
        align-items: center;
      }

      &__imageBox {
        flex-shrink: 0;
        width: 220px;

        @include max-md {
          width: 100%;
          margin-bottom: 1rem;
        }
      }

      &__infoBox {
        flex: 1;
        width: calc(100% - 420px);
        padding-left: 1.5rem;

        @include max-md {
          width: 100%;
          padding-left: 0;
        }
      }

      &__actionBox {
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        align-items: flex-end;
        justify-content: space-between;
        width: 200px;
        text-align: right;

        @include max-xl {
          width: 100%;
          margin-top: -3rem;
        }

        @include max-sm {
          margin-top: 0;
          margin-top: 1rem;
        }
      }

      &__buttonBox {
        display: flex;
        @include max-sm {
          width: 100%;
        }
      }

      &__reservationBox {
        width: 100%;
      }

      &__price {
        margin-bottom: 0.25rem;
        font-family: $font-number;
        font-size: 1.25rem;
        font-weight: 600;
        color: $color-primary;
        text-align: right;

        @include max-md {
          text-align: left;
        }
      }

      &__basePrice {
        font-family: $font-number;
        font-size: 0.875rem;
        color: #b9b9b9;
        text-align: right;
        letter-spacing: 0.1em;

        @include max-md {
          text-align: left;
        }
      }

      &__image {
        position: relative;
        display: block;
        padding-top: 78%;
        overflow: hidden;
      }

      &__imageInner {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: $color-bg-default;
        background-position: center;
        background-size: cover;
        transition: transform 0.3s;
        transform: scale(1);

        &:hover {
          // transform: scale(1.15);
        }
      }

      &__title {
        margin-bottom: 0.5rem;
        font-family: $font-serif;
        font-size: 1.125rem;
        font-weight: 600;
        color: $color-primary-dark;
        transition: color 0.3s;

        &.isButton {
          &:hover {
            color: lighten($color-primary-dark, 10%);
          }
        }
      }

      &__slogan {
        min-height: 1.25rem;
        margin-bottom: 0.25rem;
        font-size: 0.875rem;
        line-height: 1.25;
      }

      &__meta {
        margin-bottom: 0.25rem;
        font-size: 0.875rem;
        line-height: 1.75;

        &.prepaidIsExpired {
          color: $color-danger;
        }
      }

      &__times {
        display: inline-block;
        padding: 0.25rem 2rem;
        font-size: 0.875rem;
        border: 1px solid #c6c6ba;

        @include max-sm {
          width: 100%;
          text-align: center;
        }
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .orderList {
        &__item {
          &.isActive {
            background: transparent;
            border-color: $color-primary;
          }
        }
      }
    }
  }
}

.buttonList {
  display: flex;
  :global {
    .buttonList {
      &__item {
        line-height: 1em;
        &:not(:last-child) {
          padding-right: 0.25rem;
          margin-right: 0.5rem;
          border-right: 1px solid $color-line;
        }
      }
    }
  }
}
</style>
